import { FlexLayout, Text } from '@deity/falcon-ui';
import { Button, Icon, Menu, MenuItem } from '@deity-io/portal-ui';
import type { IRuntimeEnvironment } from 'contexts/UIContext';
import { UIActionTypes, UIContext } from 'contexts/UIContext';
import { CACHE_FIRST } from 'contracts/constants';
import type { FC, MouseEvent } from 'react';
import { useContext, useEffect, useState } from 'react';
import { useGetEnvironmentByAccountQuery } from 'services/graphql/generated/hooks';

const EnvironmentPicker: FC = () => {
  const ctxUi = useContext(UIContext);
  const [state, setState] = useState<{ environment?: IRuntimeEnvironment }>({
    environment: ctxUi?.state.currentEnvironment
  });

  useEffect(() => {
    if (ctxUi?.state.currentEnvironment) {
      setState({ ...state, environment: { ...ctxUi.state.currentEnvironment } });
    }
  }, [ctxUi?.state.currentEnvironment]);

  const { data: environments } = useGetEnvironmentByAccountQuery({
    variables: { limit: 50, offset: 0 },
    ...CACHE_FIRST
  });

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: MouseEvent<HTMLButtonElement> | undefined) => {
    if (event) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <FlexLayout mr="xs" bg="badgeBg" alignItems="center" css={{ borderRadius: '4px', padding: '2px 10px' }}>
      <Button style={{ height: '23px' }} variant="text" endIcon={<Icon icon="arrowDropDown" />} onClick={handleClick}>
        <Text color="secondary" mr="xs" style={{ textTransform: 'capitalize' }}>
          {ctxUi?.state.currentEnvironment?.name || 'env'}
        </Text>
      </Button>
      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleClose}>
        {environments?.getEnvironmentByAccount.data.map(environment => (
          <MenuItem
            key={environment.uuid}
            onClick={() => {
              handleClose();
              ctxUi?.dispatch({
                type: UIActionTypes.SET_CURRENT_ENVIRONMENT,
                payload: {
                  uuid: environment.uuid,
                  name: environment.name,
                  description: environment.description,
                  variables: {
                    gatewayUrl: environment.gatewayUrl
                  }
                }
              });
            }}
            icon={<Icon icon="arrowCircleRight" />}
          >
            {environment.name}
          </MenuItem>
        ))}
        <MenuItem
          key="none"
          onClick={() => {
            handleClose();
            ctxUi?.dispatch({
              type: UIActionTypes.CLEAR_CURRENT_ENVIRONMENT
            });
          }}
          icon={<Icon icon="arrowCircleRight" />}
        >
          None
        </MenuItem>
      </Menu>
    </FlexLayout>
  );
};

export default EnvironmentPicker;
